import * as z from "zod";

export const disconnectLinnworksTrackstarIntegration = {
  name: "disconnectLinnworksTrackstarIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
